import React, {useRef, useState} from 'react';
import {Button, Space, Tabs, Tooltip} from 'antd';

import {BarsOutlined, ColumnHeightOutlined, VerticalAlignMiddleOutlined} from '@/icons';
import LocalApiList from './LocalApiList';
import WecomApiList from './WecomApiList';

ApiTabs.propTypes = {};

function ApiTabs() {
    const LocalApiListRef = useRef();
    const [activeKey, setActiveKey] = useState('localApis');

    function onChange(key) {
        console.log(key);
        setActiveKey(key);
    }

    function onLocalApiSelectClick() {
        LocalApiListRef.current.onApiSelectClick();
    }

    function onLocalExpandAll() {
        LocalApiListRef.current.expandAll();
    }

    function onLocalCollapseAll() {
        LocalApiListRef.current.collapseAll();
    }

    function getExtra() {
        let tabBarExtraContent = (
                <Space size="large">
                    <Button.Group>
                        <Tooltip title="展开所有">
                            <Button icon={<ColumnHeightOutlined />} onClick={onLocalExpandAll} />
                        </Tooltip>
                        <Tooltip title="合拢所有">
                            <Button
                                icon={<VerticalAlignMiddleOutlined />}
                                onClick={onLocalCollapseAll}
                            />
                        </Tooltip>
                    </Button.Group>
                    <Button
                        type="primary"
                        icon={<BarsOutlined />}
                        onClick={onLocalApiSelectClick}
                        style={{marginRight: 16}}
                    >
                        选择接口
                    </Button>
                </Space>
            );
        return tabBarExtraContent;
    }

    return (
        <Tabs
            style={{marginTop: 24}}
            tabBarStyle={{paddingLeft: 16}}
            onChange={onChange}
            tabBarExtraContent={getExtra()}
        >
            <Tabs.TabPane key="localApis" tab="内部接口">
                { activeKey === 'localApis' &&   <LocalApiList ref={LocalApiListRef} activeKey={activeKey}/>}
            </Tabs.TabPane>
            <Tabs.TabPane key="wecomApis" tab="企微接口">
                { activeKey === 'wecomApis' &&   <LocalApiList ref={LocalApiListRef} activeKey={activeKey}/>}
            </Tabs.TabPane>
        </Tabs>
    );
}

export default ApiTabs;
